var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"work-order",attrs:{"id":"work-order"}})
}
var staticRenderFns = []

export { render, staticRenderFns }